import React, { useState } from "react";
import {
  Button,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import hospitalData from "./pages/hospitalData.json";

const LocateNearestHospitalMyLoc = () => {
  const [nearestHospital, setNearestHospital] = useState("");
  const [distanceHospital, setDistanceHospital] = useState("");
  const [validHospital, setValidHospital] = useState([]);

  function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    const R = 6371; // Radius of the Earth in km
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    return R * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
  }

  function findNearestHospital(Latitude, Longitude) {
    let minDist = Number.MAX_VALUE;
    let nearestHospitalName = "";
    let validHospTemp = [];

    hospitalData.forEach((hospital) => {
      let dist = getDistanceFromLatLonInKm(
        Latitude,
        Longitude,
        hospital.latitude,
        hospital.longitude
      );
      hospital.distance = dist;
      validHospTemp.push(hospital);
      if (dist < minDist) {
        minDist = dist;
        nearestHospitalName = hospital.name;
      }
    });

    validHospTemp.sort((a, b) => a.distance - b.distance);
    setValidHospital(validHospTemp.slice(0, 5)); // Show only top 5 hospitals
    setNearestHospital(nearestHospitalName);
    setDistanceHospital(minDist.toFixed(2));
  }

  function succeeded(position) {
    findNearestHospital(position.coords.latitude, position.coords.longitude);
  }

  function failed() {
    alert("Location fetch failed");
  }

  function findLocation() {
    navigator.geolocation.getCurrentPosition(succeeded, failed);
  }

  return (
    <div style={styles.container}>
      <div style={styles.background}></div>
      <div style={styles.content}>
        <h1 style={styles.heading}>🚨 Emergency Hospital Finder</h1>
        <p style={styles.subtext}>Find the best hospitals for emergency cases here.</p>
        <Button style={styles.button} onClick={findLocation}>
          Find Nearest Hospital
        </Button>
        {nearestHospital && (
          <Card style={styles.card}>
            <p>
              The nearest hospital is <b>{nearestHospital}</b>, approximately {distanceHospital} KM away.
            </p>
          </Card>
        )}
        {validHospital.length > 0 && (
          <div style={styles.tableWrapper}>
            <TableContainer component={Paper} style={styles.tableContainer}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell style={styles.tableHeader}>Hospital Name</TableCell>
                    <TableCell style={styles.tableHeader}>Distance (KM)</TableCell>
                    <TableCell style={styles.tableHeader}>Address</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {validHospital.map((row) => (
                    <TableRow key={row.name}>
                      <TableCell style={styles.tableCell}>{row.name}</TableCell>
                      <TableCell style={styles.tableCell}>{Math.ceil(row.distance)} Km</TableCell>
                      <TableCell style={styles.tableCell}>{row.address}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      </div>
    </div>
  );
};

// **Updated Styles**
const styles = {
  container: {
    position: "relative",
    width: "100vw",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    overflow: "hidden",
  },
  background: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundImage: `url("/emergency2.png")`, 
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    zIndex: -1,
  },
  content: {
    position: "relative",
    zIndex: 1,
    color: "white",
    padding: "20px",
    borderRadius: "10px",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    maxWidth: "800px",
    width: "90%",
  },
  heading: {
    fontSize: "2.5em",
    fontWeight: "bold",
    marginBottom: "10px",
  },
  subtext: {
    fontSize: "1.2em",
  },
  button: {
    backgroundColor: "#d9534f",
    color: "white",
    padding: "10px 20px",
    border: "none",
    cursor: "pointer",
    margin: "10px",
    borderRadius: "5px",
    fontSize: "16px",
  },
  card: {
    padding: "10px",
    marginTop: "20px",
    backgroundColor: "#ffffff",
    color: "black",
    borderRadius: "8px",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
  },
  tableWrapper: {
    width: "100%",
    maxWidth: "750px",
    overflowX: "auto",
    marginTop: "20px",
  },
  tableContainer: {
    maxHeight: "300px",
    overflowY: "auto",
    borderRadius: "10px",
    backgroundColor: "white",
    padding: "10px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
  },
  tableHeader: {
    fontWeight: "bold",
    fontSize: "16px",
    backgroundColor: "#f4f4f4",
  },
  tableCell: {
    fontSize: "14px",
    padding: "10px",
  },
  
};

export default LocateNearestHospitalMyLoc;
